import React, { useState,useEffect } from "react";

const ServerTable = () => {
  const [servers, setServers] = useState([
    { id: 1, name: "sefl", status: "Stopped", displayName: "SEFL" },
    { id: 2, name: "tgepe", status: "Running", displayName: "TGEPE" },
    { id: 3, name: "odfl", status: "Running", displayName: "ODFL" },
    { id: 4, name: "Server 4", status: "Running", displayName: "DEMO" },
    { id: 5, name: "sefl", status: "Stopped", displayName: "SEFL UAT" },
    { id: 6, name: "tgepe", status: "Running", displayName: "TGEPE UAT" },
    { id: 7, name: "odfl", status: "Stopped", displayName: "ODFL UAT" },
  ]);
  const [responseMessage, setResponseMessage] = useState(""); 

const handleServerUp = async (name: any) => {
  try {
    const response = await fetch(
      "https://opltpq2hn9.execute-api.us-east-1.amazonaws.com/dev/start1?client=" + name,
      // "https://opltpq2hn9.execute-api.us-east-1.amazonaws.com/dev/start?client=" + name,
      {
        method: "POST",
        // body: JSON.stringify({ serverName: name }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // check if API failed (400, 500 etc.)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    console.log("API Response:", data);
    setResponseMessage(data.message || ""); // update state with API response
    // alert(data.message || "No message received");

  } catch (error) {
    console.error("API error:", error);
  }
};

// useEffect(() => {
//     const fetchServers = async () => {
//       try {
//         const response = await fetch("YOUR_API_URL_HERE");

//         if (!response.ok) {
//           throw new Error("Failed to fetch");
//         }

//         const data = await response.json();

//         // 👇 directly state update
//         setServers(data);

//       } catch (error) {
//         console.error("Error fetching servers:", error);
//       }
//     };

//     fetchServers();
//   }, []); // empty array = only on page load

  return (
    <div className="p-6">
      <div className="overflow-x-auto">
        <div className="mb-4 text-sm text-gray-600 text-right font-bold">{responseMessage}</div>
        <table className="min-w-full border border-gray-300 text-center">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-4 py-2">Client</th>
              <th className="border px-4 py-2">Server Status</th>
              <th className="border px-4 py-2">Action</th>
            </tr>
          </thead>
          <tbody>
            {servers.map((server) => (
              <tr key={server.id} className="hover:bg-gray-50">
                <td className="border px-4 py-2">{server.displayName}</td>
                <td className="border px-4 py-2">
                  <span
                    className={`font-semibold ${
                      server.status === "Running"
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    {server.status}
                  </span>
                </td>
                <td className="border px-4 py-2">
                  <button
                    onClick={() => handleServerUp(server.name)}
                    disabled={server.status === "Running"}
                    className={`px-4 py-2 rounded text-white ${
                      server.status !== "Running"
                        ? "bg-blue-500 hover:bg-blue-600"
                        : "bg-gray-400 cursor-not-allowed"
                    }`}
                  >
                    Start
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ServerTable;
